<template>
  <a-layout class="main-layout" :key="`layout-${isDesktop}`">
    <div class="bg-image"></div>
    <a-layout-sider v-if="isDesktop">
      <app-menu
      />
    </a-layout-sider>

    <!--    Responsive Mobile ( < 768px ) -->
    <a-drawer
        v-if="!isDesktop"
        :visible="menuVisible"
        placement="left"
        :closable="false"
        :width="280"
        @close="menuVisible = false"
    >
      <app-menu
          @menu-click="menuVisible = false"
      />
    </a-drawer>
    <a-layout>
      <a-layout-header>
        <app-header
            :is-desktop="isDesktop"
            @toggle-menu="toggleMenu"/>
      </a-layout-header>
      <a-layout-content>
        <router-view/>
        <a-back-top/>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import Socket from '@/core/echo';
import {LANGUES_SUPPORTEES} from '@/core/vue-i18n';
import AppHeader from '@/components/layout/components/AppHeader';
import AppMenu from '@/components/layout/components/AppMenu';

export default {
  components: {
    AppHeader,
    AppMenu,
  },
  data() {
    return {
      isDesktop: window.innerWidth > 768,
      menuVisible: false,
    }
  },
  created() {
    this.debouncedHandleResize = _.debounce(this.handleResize, 200);
  },
  mounted() {
    window.addEventListener('resize', this.debouncedHandleResize);
    console.log('Component mounted.')
  },
  beforeMount() {
    Socket.installEcho(Vue);
    this.$store.dispatch('ticketsStore/GET_COUNT');

    this.updateLanguage();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedHandleResize);
    console.log('Component destroyed.')
  },
  methods: {
    updateLanguage() {
      // `if (lsLang)` ne suffisait pas : la chaîne "null" est truthy. Cf. normaliserLangue().
      const lsLang = localStorage.getItem('language');
      if (LANGUES_SUPPORTEES.includes(lsLang)) {
        this.$i18n.locale = lsLang;
      }
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    handleResize() {
      this.isDesktop = window.innerWidth > 768;
    },
  }
}
</script>

<style lang="scss" scoped>
.main-layout::v-deep {
  min-height: 100vh;
  position: relative;
  background: #F7F8FA !important;

  .bg-image {
    position: fixed;
    height: 100vh;
    width: 100%;
    background-image: url("@/assets/background.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .ant-layout-sider {
    flex: 0 0 300px !important;
    max-width: 300px !important;
    min-width: 300px !important;
    width: 300px !important;
    background: #fff;
  }

  .ant-layout-header {
    height: 130px;
    padding: 0 100px 0 60px;
    background: #F7F8FA !important;
    border-bottom: 2px solid #F4F4F4;
    z-index: 1;
  }

  .ant-layout-content {
    padding: 40px 60px 80px 60px;
    z-index: 1;
  }
}
</style>

<style lang="scss" scoped>
@media screen and (max-height: 820px) {
  .main-layout::v-deep {
    .ant-layout-header {
      height: 75px;
      padding: 0 60px 0 60px;
    }

    .ant-layout-content {
      padding: 40px 60px 80px 60px;
    }
  }
}

/* Tablet (768px - 1024px) */
@media screen and (max-width: 1024px) {
  .main-layout::v-deep {
    .ant-layout-header {
      height: 75px;
      padding: 0 32px;
    }

    .ant-layout-content {
      padding: 24px 32px 60px 32px;
    }
  }
}

/* Mobile (< 768px) — header en 2 lignes pour garder le titre visible */
@media screen and (max-width: 768px) {
  .main-layout::v-deep {
    .ant-layout-header {
      height: auto;
      padding: 12px 16px;
    }

    .ant-layout-content {
      padding: 16px 16px 60px 16px;
    }
  }
}
</style>